import { ChangeDetectionStrategy, Component, HostBinding, OnInit } from '@angular/core';
import { subjectFromObs } from 'core/rx-js';
import { Subject, map } from 'rxjs';
import { SignatureOptionsDialogService } from '../../signature-options/signature-options-dialog.service';
import { SignatureService } from '../signature.service';

@Component({
  selector: 'ss-signature-toolbar',
  templateUrl: './signature-toolbar.component.html',
  styleUrls: ['./signature-toolbar.component.scss'],
  providers: [
    SignatureOptionsDialogService
  ],
  host: {
    class: 'flex-row z10000 border-radius-smaller-top padding-smaller-inline position-relative'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignatureToolbarComponent implements OnInit {
  readonly #destroy = new Subject<void>()

  readonly backgroundSubject = subjectFromObs({
    until: this.#destroy,
    observable: this._signatureService.hueObs.pipe(map(hue => 'hsla(' + hue + ',100%,50%,0.1)')),
    initialValue: null
  })
  readonly borderObs = this._signatureService.borderObs;

  constructor(
    private _signatureService: SignatureService,
    private _signatureOptionsDialogService: SignatureOptionsDialogService
  ) {

  }

  ngOnInit(): void {
  }


  copySignature() {

  }

  openSignatureOptions() {

    this._signatureOptionsDialogService.open();

  }

  removeSignature() {

    this._signatureService.remove()

  }


  ngOnDestroy() {
    this.#destroy.next()
    this.#destroy.complete()
  }

  @HostBinding('style.background')
  get background() {
    return this.backgroundSubject.value
  }
}
